import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Quais os benefícios da Consulta?",
      answer: "Dedico 1h inteira exclusivamente a você, ao seu caso, suas expectativas e as suas necessidades. Além disso, você ganha uma Colposcopia e tem direito a um retorno em 30 dias."
    },
    {
      question: "Tem direito ao retorno?",
      answer: "Sim, o retorno acontece 30 dias após a primeira consulta e o paciente já sai com o retorno agendado."
    },
    {
      question: "Atende Plano de Saúde?",
      answer: "Para oferecer um atendimento mais completo, personalizado e sem pressa, os atendimentos são realizados de forma particular. Para informações sobre valores, entre em contato, será um prazer te atender."
    }
  ];

  const handleAgendar = () => {
    window.open("https://wa.me/5563991352552?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta.", "_blank");
  };

  return (
    <section id="faq" className="py-20 px-4 bg-secondary/10">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-textDark mb-4">
            Dúvidas Frequentes
          </h2>
          <p className="text-textLight">Tire suas dúvidas sobre meus atendimentos e procedimentos</p>
          <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl shadow-md overflow-hidden"
            >
              <button
                className="w-full px-6 py-4 text-left font-semibold text-textDark hover:bg-secondary/20 transition-colors flex justify-between items-center"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span>{faq.question}</span>
                <span className="text-2xl text-primary">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="px-6 pb-4 text-textLight border-t border-secondary/30"
                  >
                    <p className="pt-4">{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleAgendar}
            className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primaryDark transition-all duration-300 hover:scale-105"
          >
            Agendar consulta
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;